import script from "./DonutChart2.vue?vue&type=script&setup=true&lang=js"
export * from "./DonutChart2.vue?vue&type=script&setup=true&lang=js"

import "./DonutChart2.vue?vue&type=style&index=0&id=67d47e6e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67d47e6e"]])

export default __exports__